<template>
  <transition name="fade" mode="out-in" appear>
    <LoadingAnimation v-if="loadingAnimation" />
    <div v-else-if="data.length && !loadingAnimation" class="wrap">
      <div class="buttonsGroup">
        <StructureCompanyAddAndLinkWorkRoleModal showBtnType="role" />
        <StructureCompanyAddAndLinkWorkRoleModal showBtnType="group" />
        <EmployeeRolesLinkModal :create="true" />
      </div>
      <StructureCompanyTree :roles="employeeRolesGrid" />
    </div>
    <Plug v-else-if="!data.length && !loadingAnimation" />
  </transition>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import Plug from 'components/Plug'
import LoadingAnimation from 'components/LoadingAnimation'
import StructureCompanyTree from 'components/setting/structureCompany/StructureCompanyTree'
import StructureCompanyAddAndLinkWorkRoleModal from 'components/setting/structureCompany/StructureCompanyAddAndLinkWorkRoleModal'
import EmployeeRolesLinkModal from 'components/employees/EmployeeRolesLinkModal'

export default {
  name: 'StructureCompany',
  components: {
    Plug,
    LoadingAnimation,
    StructureCompanyTree,
    StructureCompanyAddAndLinkWorkRoleModal,
    EmployeeRolesLinkModal,
  },
  data() {
    return {
      data: [{ id: 1 }],
    }
  },
  created() {
    this.onEmployeeRolesGrid({
      limit: 10000000,
      page: 1,
    })
  },
  computed: {
    ...mapGetters('employeeRoles', ['employeeRolesGrid', 'pageData']),
    ...mapGetters(['loadingAnimation']),
  },
  methods: {
    ...mapActions('employeeRoles', ['onEmployeeRolesGrid']),
  },
  watch: {
    '$route.query.page'() {
      this.onOfferAgreementGrid({
        limit: this.$route.query.limit,
        page: this.$route.query.page,
      })
    },
    '$route.query.limit'() {
      this.onOfferAgreementGrid({
        limit: this.$route.query.limit,
        page: this.$route.query.page,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.wrap {
  display: grid;
  row-gap: 30px;
  .buttonsGroup {
    display: grid;
    grid-template-columns: max-content max-content max-content;
    gap: 20px;
    @media #{map-get($display-breakpoints, 'sm-only')} {
      grid-template-columns: auto 1fr;
    }
    @media #{map-get($display-breakpoints, 'xs-only')} {
      grid-template-columns: 1fr;
    }
  }
}
</style>
